import { useMutation, useQueryClient } from '@tanstack/react-query';

import { notificationService } from '@/services/notification.service';
import { adminEventService } from '@/services/admin_event.service';
import { AdminEventError } from '@/exceptions/admin-event/adminEvent.enum';

const useCreateAdminEvent = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (event: FormData) =>
            await adminEventService.newAdminEvent(event),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['adminEvent'] });
            notificationService.success("event Created Succesful");

        },

        onError: () => {
            throw new Error(AdminEventError.CREATE_ERROR);
        },
    });
};

export default useCreateAdminEvent;
